import { CreatePolicyType } from "./type";

export const createInitialState: CreatePolicyType = {
  policyNumber: "",
  insuredName: "",
  contactNumber: "",
  amount: "",
  email: "",
};
